import { useQuery } from "react-query";
import { getBusLicenseAndPermitBy } from "../../../../../actions/CarrierAgreementMgmt/BusinessLicensesAndPermits";                                          

const useGetBusinessLicensePermit  = (searchInputsData) => {
  return useQuery(["GetBusLicensePermitReport",searchInputsData],() => getBusLicenseAndPermitBy(searchInputsData),
    {
      refetchOnWindowFocus: false,      
    }
  );
   
};
export default useGetBusinessLicensePermit;
